// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__1QJkx","importantInfo":"styles_importantInfo__u6-kk"};